var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 6C4.7835 6 4 6.7835 4 7.75V8.48577C3.99984 8.49479 3.99984 8.50381 4 8.51282V16.25C4 17.2165 4.7835 18 5.75 18H18.25C19.2165 18 20 17.2165 20 16.25V8.51265C20.0002 8.50376 20.0002 8.49485 20 8.48594V7.75C20 6.7835 19.2165 6 18.25 6H5.75ZM18.5 8.07029V7.75C18.5 7.61193 18.3881 7.5 18.25 7.5H5.75C5.61193 7.5 5.5 7.61193 5.5 7.75V8.07029L12 11.8806L18.5 8.07029ZM5.5 9.80902V16.25C5.5 16.3881 5.61193 16.5 5.75 16.5H18.25C18.3881 16.5 18.5 16.3881 18.5 16.25V9.80902L12.3793 13.397C12.1451 13.5343 11.8549 13.5343 11.6207 13.397L5.5 9.80902Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bb3720ceb4e1416e6e8fc8e04c3036d3.svg";
export { ForwardRef as ReactComponent };